module.exports = __webpack_public_path__ + "img/sg.bfab3c1b.svg";